import { render, staticRenderFns } from "./FileDrop.vue?vue&type=template&id=5be31bc8&"
import script from "./FileDrop.vue?vue&type=script&lang=ts&"
export * from "./FileDrop.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports